import "./item.scss";
import ItemModal from "../itemModal/ItemModal";
import { useState } from "react";

const Item = ({ product }) => {
  const [openItemModal, setOpenItemModal] = useState(false);

  return (
    <div className="itemCard">
      <div
        className="itemContainer"
        onClick={() => {
          setOpenItemModal(true);
        }}
      >
        <div className="details"> 
          <div className="detailsLeft">
            <p className="title">{product.name}</p>
            <p className="ingredients">{product.ingredients.join(", ")}</p>
          </div>
          <div className="detailsRight">
            <p className="price">{product.price[0]}zł</p>
          </div>
        </div>
      </div>
      {openItemModal && (
        <ItemModal
          item={product}
          closeItemModal={setOpenItemModal}
          key={product._id}
        />
      )}
    </div>
  );
};
export default Item;
